import { render, staticRenderFns } from "./travelApproval.vue?vue&type=template&id=09fdf0b0&scoped=true"
import script from "./travelApproval.vue?vue&type=script&lang=js"
export * from "./travelApproval.vue?vue&type=script&lang=js"
import style0 from "./travelApproval.vue?vue&type=style&index=0&id=09fdf0b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fdf0b0",
  null
  
)

export default component.exports